import React from "react";
import { FiUsers, FiFileText, FiPlus } from "react-icons/fi";
import StatCard from "../../components/StatCard";
import UserGraph from "../../components/UserGraph";

export default function AdminDashboard() {
  // Dummy data for cards
  const totalUsers = 1280;
  const totalDocuments = 4523;

  // Dummy monthly data for UserGraph (users per month)
  const monthlyUserData = [
    { label: "Jan", value: 2 },
    { label: "Feb", value: 5 },
    { label: "Mar", value: 10 },
    { label: "Apr", value: 12 },
    { label: "May", value: 18 },
    { label: "Jun", value: 22 },
    { label: "Jul", value: 28 },
    { label: "Aug", value: 30 },
    { label: "Sep", value: 35 },
    { label: "Oct", value: 38 },
    { label: "Nov", value: 40 },
    { label: "Dec", value: 45 },
  ];

  const handleAddUsers = () => {
    // Placeholder action for demo
    alert("Add Users clicked");
  };

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 dark:text-white">
          User statistics
        </h2>
        <button
          onClick={handleAddUsers}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
        >
          <FiPlus />
          Add users
        </button>
      </div>

      {/* Cards row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <StatCard
          title="Total users"
          value={totalUsers}
          icon={FiUsers}
          accent="indigo"
        />
        <StatCard
          title="Total documents"
          value={totalDocuments}
          icon={FiFileText}
          accent="green"
        />
      </div>

      {/* Graph row */}
      <div>
        <UserGraph data={monthlyUserData} />
      </div>
    </div>
  );
}
